/**
 * A single "Job Type" label for meta titles. Jobs can carry more than one Contract Type value,
 * so take the first one entered, skipping "Remote" — that describes where the job is worked
 * rather than the type of contract, and reads poorly as "Remote Role" next to a real contract type.
 *
 * @param categories
 * @returns {string}
 */
export const getJobTypeLabel = (categories) => {
  const values = (categories || [])
    .filter((category) => category.name == "Contract Type")
    .flatMap((category) => category.values || [])
    .map((value) => String(value.name || "").trim())
    .filter(Boolean);

  return values.find((name) => name != "Remote") || values[0] || "";
};
